import { Component, inject } from '@angular/core';
import { COMPONENT_VERSIONS } from '@fgb/core';
import { MarketplaceDetailPageV1Component } from './marketplace-detail-page-v1/marketplace-detail-page-v1.component';
import { MarketplaceDetailPageV2Component } from './marketplace-detail-page-v2/marketplace-detail-page-v2.component';
import { ActivatedRoute } from '@angular/router';

const componentMap = {
  1: MarketplaceDetailPageV1Component,
  2: MarketplaceDetailPageV2Component,
};

type MarketplaceComponentVersion = keyof typeof componentMap;

/** Container component that delegates rendering to a versioned marketplace component based on COMPONENT_VERSIONS config. */
@Component({
  selector: 'fgb-marketplace-detail-page',
  template: `<ng-container *ngComponentOutlet="component; inputs: componentInputs"></ng-container>`,
})
export class MarketplaceDetailPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly marketplaceVersion = inject(COMPONENT_VERSIONS)?.marketplace as MarketplaceComponentVersion;

  get component() {
    return componentMap[this.marketplaceVersion || 1]; // default to version 1 if not specified
  }

  get componentInputs() {
    return { id: +this.route.snapshot.params['id'] };
  }
}
